var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33317 1.51558V4.26927C8.33317 4.64264 8.33317 4.82932 8.40583 4.97193C8.46975 5.09737 8.57173 5.19936 8.69718 5.26328C8.83978 5.33594 9.02647 5.33594 9.39984 5.33594H12.1535M12.3332 6.66142V11.4693C12.3332 12.5894 12.3332 13.1494 12.1152 13.5773C11.9234 13.9536 11.6175 14.2595 11.2412 14.4513C10.8133 14.6693 10.2533 14.6693 9.13317 14.6693H4.8665C3.7464 14.6693 3.18635 14.6693 2.75852 14.4513C2.3822 14.2595 2.07624 13.9536 1.88449 13.5773C1.6665 13.1494 1.6665 12.5894 1.6665 11.4693V4.53594C1.6665 3.41583 1.6665 2.85578 1.88449 2.42796C2.07624 2.05163 2.3822 1.74567 2.75852 1.55392C3.18635 1.33594 3.7464 1.33594 4.8665 1.33594H7.00769C7.49687 1.33594 7.74146 1.33594 7.97163 1.3912C8.17571 1.44019 8.3708 1.521 8.54974 1.63066C8.75157 1.75434 8.92453 1.92729 9.27043 2.2732L11.3959 4.39868C11.7418 4.74458 11.9148 4.91753 12.0385 5.11937C12.1481 5.29831 12.2289 5.4934 12.2779 5.69747C12.3332 5.92765 12.3332 6.17224 12.3332 6.66142Z",
    stroke: "#475467",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.0d2cbc4544e2264e65942a669bcb81b9.svg";
export { ForwardRef as ReactComponent };